import { months } from "../../../../shared/data/months";

export const setActiveDay = (dateSelected) => {
    const convertVal = dateSelected?.toISOString()?.split("T")[0]?.replace(/-/g, "");
    const monthsItems = document.querySelectorAll("[class*=DatePicker_monthContainer__]");
    const datesDays = document.querySelectorAll("[class*=DatePicker_dateDayItem__]");
    datesDays.forEach(el => {
        el.classList.remove("react-calendar-horizontal-dayActive")
    })

    for (let index = 0; index < monthsItems.length; index++) {
        const month = monthsItems[index];

        const spanMonth = month.querySelector("[class*=DatePicker_monthYearLabel__]");
        const [monthName, year] = spanMonth.innerHTML.split(" ");
        const monthFinder = months.find(x => (x.monthEs === monthName || x.monthEn === monthName) && monthName);
        const dateDayItem = month.querySelectorAll("[class*=DatePicker_dateDayItem__]");

        dateDayItem.forEach(el => {
            const dateLabel = el.querySelector("[class*=DatePicker_dateLabel__]")
            if (monthFinder) {
                const dateCompleted = `${year}${monthFinder.monthNumber}${Number(dateLabel.innerHTML) < 10 ? `0${dateLabel.innerHTML}` : dateLabel.innerHTML}`;
                if (convertVal === dateCompleted) {
                    el.classList.add("react-calendar-horizontal-dayActive")
                    setTimeout(() => {
                        el.scrollIntoView({
                            inline: 'center'
                        });
                    }, 200)
                    return;
                }
            }
        })
    }
}